import { Dialog, Stack, Typography, Tooltip } from '@mui/material';
import { useState } from 'react';

interface JsonDetailViewerProps {
  data: any;
  maxLength?: number;
  label?: string;
  showCopyButton?: boolean;
}

export default function JsonDetailViewer({ 
  data, 
  maxLength = 20, 
  label = "Detail",
  showCopyButton = false
}: JsonDetailViewerProps) {
  const [open, setOpen] = useState(false);
  
  const jsonString = JSON.stringify(data, null, 2);
  const shortString = jsonString.length > maxLength ? jsonString.slice(0, maxLength) + '...' : jsonString;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonString);
      // 可以添加 toast 通知
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <>
      <Tooltip title="Click to view details" arrow>
        <Typography
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '0.875rem',
            cursor: 'pointer',
          }}
          onClick={() => setOpen(true)}
        >
          {shortString}
        </Typography>
      </Tooltip>
      
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <Stack sx={{ p: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6">
              {label}
            </Typography>
            {showCopyButton && (
              <Typography
                variant="body2"
                sx={{ 
                  cursor: 'pointer', 
                  color: 'primary.main',
                  textDecoration: 'underline'
                }}
                onClick={handleCopy}
              >
                Copy JSON
              </Typography>
            )}
          </Stack>
          <pre
            style={{
              background: '#f5f5f5',
              padding: 16,
              borderRadius: 4,
              maxHeight: 500,
              overflow: 'auto',
              fontSize: 14,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {jsonString}
          </pre>
        </Stack>
      </Dialog>
    </>
  );
}
